import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApiService } from 'src/app/core/api.service';
import { LoggerService } from 'src/app/core/logger.service';
import { BlendEvent, ErrCode, LinkDeleteApiOutput } from 'src/app/shared/models';
import * as fromRoot from 'src/app/reducers';
import * as FileListActions from 'src/app/actions/file-list.actions';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { BlendService } from 'src/app/shared/services/blend.service';

@Component({
  selector: 'app-link-delete',
  templateUrl: './link-delete.component.html',
  styleUrls: ['./link-delete.component.scss']
})
export class LinkDeleteComponent implements OnInit {
  @Input() link: any;
  @Input() showDeleteLinkDialog: boolean;
  @Input() fileName: string;
  @Input() onLinkMutate?: Function;

  @Output() state = new EventEmitter<number>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<boolean>();
  @Output() showDeleteLinkDialogChange = new EventEmitter<boolean>();

  public errcode: ErrCode;
  public isButtonLoading: boolean = false;

  constructor(
      private api: ApiService,
      private log: LoggerService,
      private store: Store<fromRoot.State>,
      private snackbarService: SnackbarService,
      private blendService: BlendService,
  ) { }

  ngOnInit() {
      console.log("Delete link");
      this.showDeleteLinkDialog = true;
  }

  public closeDialog() {
      this.close.emit(false);
  }

  public delete = async() => {
      this.blendService.track(BlendEvent.BUTTON_CLICKED, { button_text: 'Confirm link deletion' });
      try {
          this.errcode = null;
          await this.api.execute<LinkDeleteApiOutput>('linkdelete', {sync_id: this.link.sync_id});
          if (this.onLinkMutate) {
            this.onLinkMutate();
          }
          else {
            this.store.dispatch(new FileListActions.FileListReloadAction());
          }
          this.close.emit(true);
          this.closeDeleteLinkDialog();
          this.snackbarService.showMessage("success", "Link has been successfully deleted.");
      } catch (e) {
        this.closeDeleteLinkDialog();
        this.log.e('Error deleting link ' + this.link.cachekey, e);
        this.errcode = ErrCode.fromException(e);
        this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
      }
  }
  onBack = () => {
    this.closeDeleteLinkDialog();
  }

  closeDeleteLinkDialog = () => {
    this.showDeleteLinkDialog = false;
    setTimeout(() => {
      this.showDeleteLinkDialogChange.next(false);
    });
  }
}
